import { getPortalLink } from '@/helpers/portalLink.js'
import {
  ROUTE_DASHBOARD,
  ROUTE_DASHBOARD_OLD,
  ROUTE_FAQ,
  ROUTE_FAQ_SUPPORT_HELP,
  ROUTE_PORTAL,
} from '@/router/routes/routeNames'

const Dashboard = () => import('@/views/Dashboard.vue')
const DashboardRedirect = () => import('@/views/DashboardRedirect.vue')
const Faq = () => import('@/views/Faq.vue')
const SupportHelp = () => import('@/views/SupportHelp.vue')

const defaultRoutes = [
  // /dashboard no longer embeds PowerBI (FAME-824/825). Customers with the
  // `hide_link_to_new_insights` flag keep the legacy dashboard at /dashboard_old;
  // everyone else is handed off to the Insights completion dashboard.
  // A component rather than `beforeEnter`: on a cold load the guard runs before
  // App.vue has loaded the company, so it cannot see the flag.
  {
    name: ROUTE_DASHBOARD,
    path: '/dashboard',
    component: DashboardRedirect,
    meta: {
      resource: 'enable_reports_dashboard',
      requiresAuth: true,
    },
  },
  // Legacy PowerBI dashboard, kept reachable during the Insights migration (FAME-826).
  // Deliberately not in the Manager sidebar; it is the fallback destination for
  // flagged customers rerouted from `/dashboard` above.
  {
    name: ROUTE_DASHBOARD_OLD,
    path: '/dashboard_old',
    component: Dashboard,
    props: true,
    meta: {
      resource: 'enable_reports_dashboard',
      requiresAuth: true,
    },
  },
  {
    name: ROUTE_FAQ,
    path: '/faq',
    component: Faq,
    meta: { requiresAuth: true, resource: 'faq' },
  },
  {
    name: ROUTE_FAQ_SUPPORT_HELP,
    path: '/faq/supportHelp',
    component: SupportHelp,
    meta: { requiresAuth: true, resource: 'faq' },
  },
  {
    name: ROUTE_PORTAL,
    path: getPortalLink(),
  },
]

export default defaultRoutes
